/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import * as React from 'react';
// import { Link } from 'gatsby';
import { PrismicProvider } from '@prismicio/react';
import './src/scss/base.scss';
import throttle from 'lodash/throttle';
import {
  PrismicPreviewProvider,
  componentResolverFromMap,
} from 'gatsby-plugin-prismic-previews';
import { registerListener, addScript } from './src/utilities/general';
import { linkResolver } from './src/utilities/linkResolver';
import HomeTemplate from './src/pages/index';
// import PageTemplate from './src/pages/{PrismicPage.url}';

/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint import/prefer-default-export: 0 */
/* eslint react/jsx-filename-extension: 0 */

export const wrapRootElement = ({ element }) => (
  <PrismicProvider>
    <PrismicPreviewProvider
      repositoryConfigs={[
        {
          repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
          linkResolver,
          componentResolver: componentResolverFromMap({
            homepage: HomeTemplate,
            // page: PageTemplate,
          }),
        },
      ]}
    >
      {element}
    </PrismicPreviewProvider>
  </PrismicProvider>
);

/**
 * Update view height
 */
const updateViewHeight = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const vh = window.innerHeight * 0.01;

  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

if (typeof window !== 'undefined') {
  registerListener(window, 'resize', throttle(updateViewHeight, 250));
}

updateViewHeight();

/*
 * COOKIE HUB HELPER FUNCTION
 * This is used when we are loading the Cookie Hub script
 */
const cookieHubOnloadFunction = () => {
  const cpm = {
    onInitialise: status => {
      if (typeof this !== 'undefined') {
        if (this.hasConsented('analytics')) {
          window['ga-disable-UA-156530598-1'] = false;
          // console.log('On initialise, GA is enabled');
        }
      }
    },
    onStatusChange: (status, previousStat) => {
      // console.log('Status:', status);
      // console.log('Previous Status:', previousStat);

      status.categories.forEach(cat => {
        if (cat.id === 'analytics') {
          window['ga-disable-UA-156530598-1'] = !cat.value;
          // console.log(`On change, GA is ${cat.value.toString()}`);
        }
      });
    },
    onAllow: category => {
      if (category === 'analytics') {
        window['ga-disable-UA-156530598-1'] = false;
        // console.log('On allow, GA is enabled');
      }
    },
    onRevoke: category => {
      if (category === 'analytics') {
        window['ga-disable-UA-156530598-1'] = true;
        // console.log('On revoke, GA is disabled');
      }
    },
  };

  window.cookiehub.load(cpm);
};

/**
 * Processes for on intial client entry
 */
export const onClientEntry = () => {
  // Disable analytics by default.
  // Need to comment this out if we decide to not use CookieHub
  window['ga-disable-UA-156530598-1'] = true;

  if (process.env.NODE_ENV === 'production') {
    addScript('https://cookiehub.net/c2/c8886e72.js', cookieHubOnloadFunction);
  } else {
    addScript('https://cookiehub.net/dev/c2/c8886e72.js', cookieHubOnloadFunction);
  }
};

/**
 * Options for after a new route is started to load
 *
 * @param location
 * @param prevLocation
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  // console.log('new pathname', location.pathname);
  // console.log('old pathname', prevLocation ? prevLocation.pathname : null);
};
